<div fxFill fxLayoutAlign="space-between start">
    <ng-container *ngFor="let field of rows; index as rowIndex">
        <div [fxFlex]="maxWidth" class="detail-labeled-field">
            <labeled-field [label]="field.Label" [ngClass]="getClass(field)">
                <ng-container *ngIf="!isAction(field)">
                    <div *ngIf="!isBoolean(field)" class="pre-wrap">
                        {{getValue(field)}}
                    </div>

                    <ng-container *ngIf="isBoolean(field)">
                        <div fxLayout="row" fxLayoutAlign="center center" class="boolean">
                            <mat-icon *ngIf="isTrue(field)" fontIcon="check_circle" class="true">
                            </mat-icon>

                            <mat-icon *ngIf="!isTrue(field)" fontIcon="do_not_disturb">
                            </mat-icon>
                            &nbsp;
                        </div>
                    </ng-container>
                </ng-container>

                <a *ngIf="isAction(field)" (click)="performFieldCommand($event, field)" class="link" [attr.aria-label]="getActionAriaLabel(field)" [attr.telemetry]="getActionAriaLabel(field)">

                    <div *ngIf="!isBoolean(field)" class="pre-wrap">
                        {{getValue(field)}}
                    </div>

                    <ng-container *ngIf="isBoolean(field)">
                        <div fxLayout="row" fxLayoutAlign="center center" class="boolean">
                            <mat-icon *ngIf="isTrue(field)" fontIcon="check_circle" class="true">
                            </mat-icon>

                            <mat-icon *ngIf="!isTrue(field)" fontIcon="do_not_disturb">
                            </mat-icon>
                            &nbsp;
                        </div>
                    </ng-container>
                </a>
            </labeled-field>
        </div>
    </ng-container>
</div>